import { useState } from "react";

const FreeHand = () => {
  const [text, setText] = useState("");
  const wordCount = text.trim() === "" ? 0 : text.trim().split(/\s+/).length;

  return (
    <div className="mt-10 p-4 sm:p-4 md:p-6 max-w-3xl mx-auto">
      <h2 className="flex flex-row gap-1 items-center text-3xl sm:text-3xl md:text-5xl font-caveat dark:text-gray-300 mb-2">
        <i class="ri-keyboard-line"></i>
        <span>Warm Up your hands here ..</span>
      </h2>

      <div className="mt-3 mb-2 text-gray-700 dark:text-gray-300 text-sm ">
        Words typed: <span className="font-bold">{wordCount}</span>
      </div>
      {/* Textarea */}
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Start typing here..."
        className="h-48 scrollbar-small bg-white font-medium w-full border border-yellow-300 dark:border-gray-800 rounded p-3 text-gray-900 placeholder-yellow-600 dark:placeholder-gray-400 dark:text-gray-100 dark:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-yellow-600 focus:border-transparent resize-y"
      />

    </div>
  );
};

export default FreeHand;
